/* eslint-disable react-hooks/exhaustive-deps */
import { SimpleWrapper } from 'components/InputsMex/containers';
import { BaseButton, PrimeTextInput, TextInputMask } from 'components/InputsMex/inputs';
import { emailRegex } from 'components/InputsMex/validaciones';
import Page from 'components/Page';
import {
  urlActualizarSegukids,
  urlCatalogoCotizador,
  urlCotizacionSegukids,
  urlMaxChildSegukids,
} from 'constants/urls';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import Loading from 'wrappers/Loading';
import { validateRequiredRule } from '../GarantiaExtendida/utils/validations';
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import BreadCrumbSegukids from 'components/BreadCrumbMex/BreadCrumbSegukids';
import useCustomRouter from 'hooks/useCustomRouter';
import useUsuario from 'hooks/useUsuario';
import COLORS from 'utils/constants/COLORS';
import { regex } from 'utils/validaciones';
import InformacionAgente from '../../components/MisDatosForm/InformacionAgente';

const CotizacionKids = ({ qParams }) => {
  const { idCotizacion } = qParams;
  const methods = useForm({ mode: 'onChange' });
  const { handleSubmit } = methods;
  const [loading, setLoading] = useState(false);

  const history = useCustomRouter();

  const [idCotiza, setidCotiza] = useState();

  const [comboCodigo, setcomboCodigo] = useState();

  const { userIsLoggedIn, cliCodigoCore } = useUsuario();

  const [urlTerminos, setUrlTerminos] = useState();
  const dataContratante = async () => {
    setLoading(true);
    const data = await ApiKeyFetch.instance().post(urlCatalogoCotizador, {
      idCotizacion: idCotizacion,
    });
    if (data.transaccion === true) {
      const formContratante = {
        nombres: data.data.datosContratante.usuNombre,
        correo: data.data.datosContratante.usuCorreo,
        telefono: data.data.datosContratante.usuTelefono,
      };
      methods.reset(formContratante);
    }
    setLoading(false);
  };

  const getData = async () => {
    setLoading(true);
    const body = {
      nombrecatalogo: 'hijos',
      usuCotiza: {
        usuCodigo: cliCodigoCore || '',
      },
    };
    const { transaccion, data } = await ApiKeyFetch.instance().post(urlMaxChildSegukids, body);

    if (transaccion) {
      let terminos = data.catalogo.urlTerminos;
      setUrlTerminos(terminos);

      const codeAgente = data.catalogo.agentes?.map((item) => ({
        label: item.value + ' , ' + item.label,
        value: {
          label: item.label,
          value: item.value,
        },
      }));

      setcomboCodigo(codeAgente);
    }
    setLoading(false);
  };

  const guardarFormulario = async (formData) => {
    let agenteValue = null;
    if (!userIsLoggedIn && comboCodigo) {
      agenteValue = comboCodigo[0].value.value;
    } else {
      agenteValue = formData.agente.value.value;
    }

    setLoading(true);
    try {
      let body = {
        usuCotiza: {
          usuCodigo: cliCodigoCore || '',
          codigoAgente: agenteValue,
        },
        informacionCliente: {
          nombres: formData.nombres,
          correo: formData.correo,
          telefono: formData.telefono,
        },
        idCotizacion: '',
        pasoCodigo: 'crearCarrito',
      };

      const resCotizacion = await ApiKeyFetch.instance().post(urlCotizacionSegukids, body);

      if (resCotizacion?.transaccion === true) {
        let cotizacion = resCotizacion.data.idCotizacion;
        history.push(`/kids/planes?idCotizacion=${cotizacion}`);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const actualizarFormulario = async (formData) => {
    setLoading(true);
    let agenteValue = null;
    if (!userIsLoggedIn && comboCodigo) {
      agenteValue = comboCodigo[0].value.value;
    } else {
      agenteValue = formData.agente.value.value;
    }
    try {
      let body = {
        usuCotiza: {
          usuCodigo: cliCodigoCore || '',
          codigoAgente: agenteValue,
        },
        informacionCliente: {
          nombres: formData.nombres,
          correo: formData.correo,
          telefono: formData.telefono,
        },
        idCotizacion: idCotizacion,
        pasoCodigo: 'informacionCliente',
      };
      const resCotizacion = await ApiKeyFetch.instance().post(urlActualizarSegukids, body);
      //console.log("Actualiza", resCotizacion);
      if (resCotizacion?.transaccion === true) {
        let cotizacion = resCotizacion.data.idCotizacion;
        history.push(`/kids/planes?idCotizacion=${cotizacion}`);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const onGuardar = async () => {
    const data = methods.getValues();
    const formData = { ...data };
    if (idCotizacion === '' || idCotizacion === null || idCotizacion === undefined) {
      await guardarFormulario(formData);
    } else {
      await actualizarFormulario(formData);
    }
  };

  useEffect(() => {
    getData();
    dataContratante();
  }, []);

  return (
    <Loading loading={loading}>
      <Page>
        <div className="container">
          <BreadCrumbSegukids
            {...PASOS_BREADCRUMBS[PRODUCTOS.SEGUKIDS].breadCrumbPasosSegukids[1]}
            pasos={PASOS_BREADCRUMBS[PRODUCTOS.SEGUKIDS]?.pasosContratante}
            showImg={false}
            showImgTitle={true}
            subtitleClassnames={'col-md-12 p-0'}
            classNameContent={'p-0'}
          />
        </div>
        <div className="container">
          <div className="border mx-1 ">
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(onGuardar)}>
                <div className="row px-5">
                  <div className="col-md-12 mt-5">
                    <h2 className="text-center text-mex">Datos del Contratante</h2>
                  </div>
                  <div className="col-md-6  ">
                    <SimpleWrapper label="Nombre del padre, madre o tutor*" name="nombres" extrasClasses="margin-0">
                      <PrimeTextInput name="nombres" rules={{ required: 'Campo obligatorio' }} />
                    </SimpleWrapper>
                  </div>
                  <div className="col-md-6 ">
                    <SimpleWrapper label="Correo*" name="correo" extrasClasses="margin-0">
                      <PrimeTextInput
                        name="correo"
                        rules={{
                          required: 'Campo obligatorio',
                          validate: {
                            required: validateRequiredRule(),
                          },
                          pattern: {
                            value: emailRegex,
                            message: 'Debe ingresar un correo válido',
                          },
                        }}
                      />
                    </SimpleWrapper>
                  </div>
                  <div className="col-md-6 ">
                    <SimpleWrapper label="Teléfono*" name="telefono" extrasClasses="margin-0">
                      <TextInputMask
                        rules={{
                          required: 'Este campo es obligatorio',
                          pattern: {
                            value: regex.telefono10.value,
                            message: regex.telefono10.mensaje,
                          },
                          minLength: {
                            value: 10,
                            message: 'Debe ingresar mínimo 10 números',
                          },
                          maxLength: {
                            value: 20,
                            message: 'Solo puede ingresar máximo 20 números',
                          },
                        }}
                        mask="999-9999-999"
                        placeholder="099-9999-999"
                        name="telefono"
                      />
                    </SimpleWrapper>
                  </div>

                  <div className="col-md-12">
                    <InformacionAgente border={false} options={comboCodigo} userIsLoggedIn={userIsLoggedIn} />

                    <a href={urlTerminos} target="_blank" rel="noopener noreferrer">
                      Revisa nuestro aviso de privacidad aquí
                    </a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4 offset-md-4 mb-5">
                    <BaseButton type="submit" textColor="white" bgColor={COLORS.primary}>
                      Continuar{' '}
                      <i
                        className="pi pi-arrow-right"
                        style={{
                          position: 'relative',
                          top: '1px',
                          fontSize: '1.4rem',
                        }}
                      />
                    </BaseButton>
                  </div>
                </div>
              </form>
            </FormProvider>
          </div>
        </div>
      </Page>
    </Loading>
  );
};

export default CotizacionKids;
